import * as React from 'react';
import { todayString } from 'src/utils/dates';
export default function TaskCardSubtitleV2(props) {
    var task = props.task;
    var externalCode = !task.externalCode
        ? null
        : React.createElement("div", null,
            React.createElement("small", null,
                "K\u00FCls\u0151 k\u00F3d (rajzsz\u00E1m): ",
                task.externalCode));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            "Projekt: ",
            task.project),
        React.createElement("div", null,
            React.createElement("small", null,
                "Hat\u00E1rid\u0151: ",
                todayString(new Date(task.deadline)))),
        React.createElement("div", null,
            React.createElement("small", null, task.title)),
        React.createElement("div", null,
            React.createElement("small", null,
                "\u00DCtem: ",
                task.stepName)),
        React.createElement("div", null, externalCode)));
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskCardSubtitle.v2.tsx
// module id = 370
// module chunks = 0